import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

const Loading = () => (
  <Player
    autoplay
    loop
    src="https://assets2.lottiefiles.com/packages/lf20_gm0fuc3m.json"
    style={{ height: '400px', width: '400px' }} />
)

export default Loading;
// "https://assets7.lottiefiles.com/datafiles/WZMt4Klgo3TYk1R/data.json"